export default __webpack_public_path__ + "static/media/NERO.1dc1e694.png";